import { connect } from 'react-redux';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import momentPropTypes from 'react-moment-proptypes';
import ProgressButtons from './ProgressButtons';
import {
  getOperatorUser,
  getExpandedOperatorUser,
  getCheckedOperatorUser,
  getSelectedOperatorUser,
} from '../../target-node-operator-user-selector/redux/selectors/OperatorUserSelector';
import OperatorUserSelector from '../../target-node-operator-user-selector/components/OperatorUserSelector';
import {
  getPeriodSelectorEndDate,
  getPeriodSelectorStartDate,
} from '../../period-selector/redux/selectors/PeriodSelectionSelectors';
import {
  retrieveOperatorUserRequestActionCreator,
  onDeSelectAllOperatorUser,
  onSelectAllOperatorUser,
  operatorUserCheckedActionCreator,
  onOperatorUserExpanded,
} from '../../target-node-operator-user-selector/redux/actions/OperatorUserActions';
import * as LocationTypes from '../../../common/redux/actions/types/LocationTypes';
import sc from '../../../common/redux/actions/types/SelectionCriteriaTypes';
/* eslint-disable import/no-cycle */
import scDefinitions from '../../../common/config/SelectionCriteriaDefinitions';
import noop from '../../../../core/modules/common/tools/noop';

const mapDispatchToProps = dispatch => bindActionCreators({
  retrieveOperatorUserRequestActionCreator,
  operatorUserCheckedActionCreator,
  onOperatorUserExpanded,
  onSelectAllOperatorUser,
  onDeSelectAllOperatorUser,
}, dispatch);

const mapStateToProps = state => ({
  selectedOperatorUserNodes: getSelectedOperatorUser(state),
  operatorUserNodes: getOperatorUser(state),
  checkedOperatorUser: getCheckedOperatorUser(state),
  expandedOperatorUser: getExpandedOperatorUser(state),
  startDate: getPeriodSelectorStartDate(state),
  endDate: getPeriodSelectorEndDate(state),
});

class TargetNodeOperatorUserWizardContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstOperatorUser: true,
      selectionTreeLoaded: false,
      showOnlySelectedOperatorUser: false,
    };
  }

  componentDidMount() {
    this.props.retrieveOperatorUserRequestActionCreator(
      {
        startDate: this.props.startDate,
        endDate: this.props.endDate,
      },
      this.props.checkedOperatorUser,
    );
  }

  async UNSAFE_componentWillReceiveProps(nextProps) {
    await this.props.selectedOperatorUserNodes;
    // eslint-disable-next-line max-len
    if (this.state.firstOperatorUser && this.props.operatorUserNodes === nextProps.operatorUserNodes && nextProps.selectedOperatorUserNodes.length !== 0) {
      this.setState({
        firstOperatorUser: false,
        showOnlySelectedOperatorUser: true,
      });
    }

    await this.props.operatorUserNodes;
    this.setState({
      selectionTreeLoaded: this.props.operatorUserNodes.length > 0,
    });
  }

  onSelectAllOperatorUser = () => {
    this.props.onSelectAllOperatorUser(this.props.operatorUserNodes);
  };

  onDeSelectAllOperatorUser = () => {
    this.setState({
      showOnlySelectedOperatorUser: false,
    });
    this.props.onDeSelectAllOperatorUser();
  };

  onSelectOperatorUser = (selected) => {
    if (selected.length === 0) {
      this.setState({
        showOnlySelectedOperatorUser: false,
      });
    } else {
      this.setState({
        firstOperatorUser: false,
      });
    }
    this.props.operatorUserCheckedActionCreator(selected, this.props.children.report);
  };

  onExpandOperatorUser = (expanded) => {
    this.props.onOperatorUserExpanded(expanded);
  };

  onToggleShowOnlySelectedOperatorUser = () => {
    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      showOnlySelectedOperatorUser: !this.state.showOnlySelectedOperatorUser,
    });
  };

  render() {
    const tempNodes = [
      {
        value: 'DUMMY',
        label: 'LOADING...',
        expandDisabled: true,
        children: this.props.checkedOperatorUser && this.props.checkedOperatorUser.length > 0 ?
          this.props.checkedOperatorUser.map(initialItem => ({ value: initialItem, label: '' })) : [],
      }];

    const operatorUserSelectorProps = {
      selected: this.props.checkedOperatorUser,
      expanded: !this.state.selectionTreeLoaded ? [] : this.props.expandedOperatorUser,
      // eslint-disable-next-line max-len
      expandDisabled: !this.state.selectionTreeLoaded ? true : this.props.children.report.locationType === LocationTypes.OPERATOR,
      // eslint-disable-next-line max-len
      isShowOnlySelected: !this.state.selectionTreeLoaded ? true : this.state.showOnlySelectedOperatorUser,
      // eslint-disable-next-line max-len,no-nested-ternary
      operatorUserNodes: !this.state.selectionTreeLoaded ? tempNodes : this.state.showOnlySelectedOperatorUser ?
        this.props.selectedOperatorUserNodes : this.props.operatorUserNodes,
      // eslint-disable-next-line max-len
      originalOperatorUserNodes: !this.state.selectionTreeLoaded ? tempNodes : this.props.operatorUserNodes,
      onExpand: !this.state.selectionTreeLoaded ? noop : this.onExpandOperatorUser,
      onSelect: !this.state.selectionTreeLoaded ? noop : this.onSelectOperatorUser,
      onSelectAll: !this.state.selectionTreeLoaded ? noop : this.onSelectAllOperatorUser,
      onDeSelectAll: !this.state.selectionTreeLoaded ? noop : this.onDeSelectAllOperatorUser,
      // eslint-disable-next-line max-len
      onShowOnlySelected: !this.state.selectionTreeLoaded ? noop : this.onToggleShowOnlySelectedOperatorUser,
      openSaveSelectionModal: !this.state.selectionTreeLoaded ? noop : this.openSaveSelectionModal,
    };

    const selectionCriteria = this.props.children.report.selectionCriteria.items;
    const SC_CODE = sc.SC050;
    const nextSelectionCriteriaRouteName = (
      scDefinitions[selectionCriteria[selectionCriteria.indexOf(SC_CODE) + 1]] || {}
    ).routeName;
    /* eslint-disable react/jsx-indent */
    return (
      <div className="operator-selector-wrapper">
        <div className="operators">
          <div className="operators-selection-panel">
            <div className="operator">
              <OperatorUserSelector
                title="OPERATOR/USER"
                {...operatorUserSelectorProps}
              />
            </div>
          </div>

          <div className="actions">
            <ProgressButtons
              next={this.props.children.routes[nextSelectionCriteriaRouteName]}
            />
          </div>
        </div>
      </div>);
  }
}

TargetNodeOperatorUserWizardContainer.propTypes = {
  report: PropTypes.shape({
    selectionCriteria: PropTypes.objectOf(PropTypes.shape),
    reportDirections: PropTypes.arrayOf(PropTypes.string),
    locationType: PropTypes.string,
  }),
  routes: PropTypes.objectOf(PropTypes.shape),
  retrieveOperatorUserRequestActionCreator: PropTypes.func,
  selectedOperatorUserNodes: PropTypes.arrayOf(PropTypes.object),
  operatorUserNodes: PropTypes.arrayOf(PropTypes.object),
  checkedOperatorUser: PropTypes.arrayOf(PropTypes.string),
  expandedOperatorUser: PropTypes.arrayOf(PropTypes.string),
  operatorUserCheckedActionCreator: PropTypes.func,
  onOperatorUserExpanded: PropTypes.func,
  onSelectAllOperatorUser: PropTypes.func,
  onDeSelectAllOperatorUser: PropTypes.func,
  // eslint-disable-next-line react/no-typos
  startDate: momentPropTypes.momentObj,
  // eslint-disable-next-line react/no-typos
  endDate: momentPropTypes.momentObj,
  /* eslint-enable react/no-typos */
};

/* Needed for prop-types with cloneElement */
export const ConnectedTargetNodeOperatorUserWizardContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(TargetNodeOperatorUserWizardContainer);

export default (ConnectedTargetNodeOperatorUserWizardContainer);
